<p-toast></p-toast>
<p-panel header="Установки" *ngIf="edited as edit">
  <p-accordion [multiple]="true" (onOpen)="onTabOpen($event)">
    <p-accordionTab [selected]="(userAccessGroup == 0)" [cache]="false" *ngIf="editconn as econ">
      <ng-template pTemplate="header">
        <h5>Подключение</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>

        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData1">Сервер API</label>
          <!--          <input id="connData1" type="text" pInputText [(ngModel)]="econ.apiSrvAddress">-->
          <p-dropdown id="connData1" [options]="apiServers" [(ngModel)]="econ.apiSrvAddress" placeholder="Выберите сервер API" [editable]="true"></p-dropdown>

        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData2">Сервер баз данных</label>
          <!--          <input id="connData2" type="text" pInputText [(ngModel)]="econ.dbSrvAddress">-->
          <p-dropdown id="connData2" [options]="dbServers" [(ngModel)]="econ.dbSrvAddress" placeholder="Выберите сервер баз данных" [editable]="true"></p-dropdown>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData3">База данных</label>
          <input id="connData3" type="text" pInputText [(ngModel)]="econ.dataBaseName" disabled>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData4">Имя пользователя в базе данных</label>
          <input id="connData4" type="text" pInputText [(ngModel)]="econ.dbUserLogin" disabled>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData5">Сервер авторизации</label>
          <!--          <input id="connData5" type="text" pInputText [(ngModel)]="econ.authSrvAddress">-->
          <p-dropdown id="connData5" [options]="authServers" [(ngModel)]="econ.authSrvAddress" placeholder="Выберите сервер авторизации" [editable]="true" [disabled]="true"></p-dropdown>
        </div>
        <div class="field col-12 xl:col-6 sm:col-12">
          <label for="connData6">Сервер отчетов</label>
          <!--          <input id="connData6" type="text" pInputText [(ngModel)]="econ.reportSrvAddress">-->
          <p-dropdown id="connData6" [options]="econ.reportServer.items1" [(ngModel)]="econ.reportSrvAddress"
                      tooltip="({{econ.reportSrvAddress}})"
                      placeholder="Выберите настройку сервера отчетов" [editable]="true"></p-dropdown>
        </div>
      </div>

      <div class="grid formgrid ">
        <div class="col pt-3 pr-3">
          <div class="grid justify-content-end">
            <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(5)"></p-button>
          </div>
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab [selected]="true" [cache]="false">
      <ng-template pTemplate="header">
        <h5>Основная организация и склады</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="col-4 xl:col-4 sm:col-12">
          <app-companyselector labelKey="Основная организация" [parentCompany]="0" [selectedID]="edit.mainCompanyId" (selectedCompanyID)="mainCompanySelected($event)" [readonly]="true"></app-companyselector>
        </div>
        <div class="col-4 xl:col-4 sm:col-12">
          <app-personselector labelKey="Контактное лицо" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.mainPersonId" (selectedPersonID)="mainPersonSelected($event)" [readonly]="true"></app-personselector>
        </div>
        <div class="col-4 xl:col-4 sm:col-12">
          <app-companyselector labelKey="По умолчанию счет от" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.defaultTradeCompanyId" (selectedCompanyID)="pcoCompanySelected($event)"></app-companyselector>
        </div>
      </div>
      <div class="fluid grid formgrid " appStopAccordionHomeEnd>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Основной склад" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.mainStockId" (selectedDepartmentID)="mainStockSelected($event)"></app-departmentselector>
        </div>
      </div>
      <div class="fluid grid formgrid " appStopAccordionHomeEnd>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Импортный склад" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.impStockId" (selectedDepartmentID)="impStockSelected($event)"></app-departmentselector>
        </div>
        <div class="col-3 xl:col-3 sm:col-6 align-self-center">
          <p-checkbox [(ngModel)]="edit.impCountFlag" label="Учитывать с основным ({{edit.impCountFlag}})" [binary]="true" [trueValue]="1" [falseValue]="0"></p-checkbox>
        </div>
      </div>
      <div class="fluid grid formgrid " appStopAccordionHomeEnd>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Вспомогательный склад" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.auxStockId" (selectedDepartmentID)="auxStockSelected($event)"></app-departmentselector>
        </div>
        <div class="col-3 xl:col-3 sm:col-6 align-self-center">
          <p-checkbox [(ngModel)]="edit.auxCountFlag" label="Учитывать с основным ({{edit.auxCountFlag}})" [binary]="true" [trueValue]="1" [falseValue]="0"></p-checkbox>
        </div>
      </div>
      <div class="fluid grid formgrid " appStopAccordionHomeEnd>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Платежи" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.paidDepartmentId" (selectedDepartmentID)="paidStockSelected($event)"></app-departmentselector>
        </div>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Займы" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.cashDepartmentId" (selectedDepartmentID)="cashStockSelected($event)"></app-departmentselector>
        </div>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Сборка" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.manDepartmentId" (selectedDepartmentID)="manStockSelected($event)"></app-departmentselector>
        </div>
        <div class="col-3 xl:col-3 sm:col-6">
          <app-departmentselector labelKey="Комплектация" [parentCompany]="edit.mainCompanyId" [selectedID]="edit.auxDepartmentId" (selectedDepartmentID)="varStockSelected($event)"></app-departmentselector>
        </div>
      </div>
      <div class="grid formgrid ">
        <div class="col pt-3 pr-3">
          <div class="grid justify-content-end">
            <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(1)"></p-button>
          </div>
        </div>
      </div>
    </p-accordionTab>
    <p-accordionTab [selected]="true" [cache]="false">
      <ng-template pTemplate="header">
        <h5>Валюты</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="col-12 p-md-6 xl:col-3">
          <app-currencyselector labelKey="Основная валюта" (SelectedCurrency)="getSelectedMCurrency($event)" [selectedID]="edit.mainCurrencyId"></app-currencyselector>
        </div>
        <div class="col-12 p-md-6 xl:col-3">
          <app-currencyselector labelKey="Валюта баланса" (SelectedCurrency)="getSelectedBCurrency($event)" [selectedID]="edit.balanceCurrencyId"></app-currencyselector>
        </div>
        <div class="col-12 p-md-6 xl:col-3">
          <app-currencyselector labelKey="Валюта для обзора 2" (SelectedCurrency)="getSelectedDCurrency($event)" [selectedID]="edit.viewDCurrencyId"></app-currencyselector>
        </div>
        <div class="col-12 p-md-6 xl:col-3">
          <app-currencyselector labelKey="Валюта для обзора 3" [selectedID]="edit.viewECurrencyId" (SelectedCurrency)="getSelectedECurrency($event)"></app-currencyselector>
        </div>
      </div>
      <div class="grid formgrid ">
        <div class="col pt-3 pr-3">
          <div class="grid justify-content-end">
            <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(2)"></p-button>
          </div>
        </div>
      </div>
    </p-accordionTab>

<!--    <ng-container *ngIf="userAccessGroup > 200000">-->
    <ng-container *ngIf="isAdminRole">

      <p-accordionTab [cache]="false">
        <ng-template pTemplate="header">
          <h5>Печатные формы</h5>
        </ng-template>
        <app-edit-print-reports appStopAccordionHomeEnd></app-edit-print-reports>
      </p-accordionTab>

      <p-accordionTab header="">
        <ng-template pTemplate="header">
          <h5>Документы</h5>
        </ng-template>
        <app-edit-doc-types appStopAccordionHomeEnd></app-edit-doc-types>
      </p-accordionTab>

    </ng-container>

    <p-accordionTab [cache]="false">
      <ng-template pTemplate="header">
        <h5>Settings raw data</h5>
      </ng-template>
      <div class="fluid formgrid grid" appStopAccordionHomeEnd>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="mainCompanyId1">mainCompanyId {{edit.mainCompanyId}}</label>
          <input id="mainCompanyId1" type="text" pInputText [(ngModel)]="edit.mainCompanyId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="mainPersonId2">mainPersonId</label>
          <input id="mainPersonId2" type="text" pInputText [(ngModel)]="edit.mainPersonId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="vatValue3">vatValue</label>
          <input id="vatValue3" type="text" pInputText [(ngModel)]="edit.vatValue">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="mainCurrencyId4">mainCurrencyId</label>
          <input id="mainCurrencyId4" type="text" pInputText [(ngModel)]="edit.mainCurrencyId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="balanceCurrencyId5">balanceCurrencyId</label>
          <input id="balanceCurrencyId5" type="text" pInputText [(ngModel)]="edit.balanceCurrencyId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="viewDCurrencyId18">viewDCurrencyId</label>
          <input id="viewDCurrencyId18" type="text" pInputText [(ngModel)]="edit.viewDCurrencyId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="viewECurrencyId17">viewECurrencyId</label>
          <input id="viewECurrencyId17" type="text" pInputText [(ngModel)]="edit.viewECurrencyId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="mainStockId6">mainStockId</label>
          <input id="mainStockId6" type="text" pInputText [(ngModel)]="edit.mainStockId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="impStockId7">impStockId</label>
          <input id="impStockId7" type="text" pInputText [(ngModel)]="edit.impStockId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="auxStockId8">auxStockId</label>
          <input id="auxStockId8" type="text" pInputText [(ngModel)]="edit.auxStockId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="impCountFlag9">impCountFlag</label>
          <input id="impCountFlag9" type="text" pInputText [(ngModel)]="edit.impCountFlag">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="auxStockId10">auxCountFlag</label>
          <input id="auxStockId10" type="text" pInputText [(ngModel)]="edit.auxCountFlag">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="manDepartmentId11">manDepartmentId</label>
          <input id="manDepartmentId11" type="text" pInputText [(ngModel)]="edit.manDepartmentId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="auxDepartmentId12">auxDepartmentId</label>
          <input id="auxDepartmentId12" type="text" pInputText [(ngModel)]="edit.auxDepartmentId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="paidDepartmentId13">paidDepartmentId</label>
          <input id="paidDepartmentId13" type="text" pInputText [(ngModel)]="edit.paidDepartmentId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="cashDepartmentId14">cashDepartmentId</label>
          <input id="cashDepartmentId14" type="text" pInputText [(ngModel)]="edit.cashDepartmentId">
        </div>
        <div class="field col-12 xl:col-2 p-md-3 sm:col-3">
          <label for="defaultTradeCompanyId15">defaultTradeCompanyId</label>
          <input id="defaultTradeCompanyId15" type="text" pInputText [(ngModel)]="edit.defaultTradeCompanyId">
        </div>
        <div class="field col-12 p-md-6 sm:col-12">
          <label for="urlPrefixString16">urlPrefixString</label>
          <input id="urlPrefixString16" type="text" pInputText [(ngModel)]="edit.urlPrefixString">
        </div>
      </div>
      <div class="grid formgrid ">
        <div class="col pt-3 pr-3">
          <div class="grid justify-content-end">
            <p-button label="Сбросить" icon="pi pi-reset" (click)="onReset()" styleClass="mr-3"></p-button>
            <p-button label="Сохранить" icon="pi pi-check" (onClick)="onConfirm(4)"></p-button>
          </div>
        </div>
      </div>
    </p-accordionTab>

  </p-accordion>

</p-panel>
